import { useRef } from 'react';

export default function useListEntries(
  list,
  createListEntry,
  indexer = (i) => i,
) {
  const entries = useRef(null);
  const listLength = useRef(null);

  if (listLength.current !== list.length) {
    const refs = {};

    for (let i = 0; i < list.length; i += 1) {
      refs[indexer(i)] = createListEntry(i);
    }

    entries.current = refs;
    listLength.current = list.length;
  }

  return entries.current;
}
